// extracted by mini-css-extract-plugin
export default {"modal":"TimeSlotModal_modal__JZcH0","zoneInfo":"TimeSlotModal_zoneInfo__FsT4X","green":"TimeSlotModal_green__tIPLp","blue":"TimeSlotModal_blue__Mgtk5"};